import { useState, useEffect } from 'react'
import { THEME_COLORS } from '../data/mockData'

export function useThemeColor() {
  const [themeColor, setThemeColor] = useState(THEME_COLORS[0].value)

  useEffect(() => {
    document.documentElement.style.setProperty('--accent-color', themeColor)
  }, [themeColor])

  return { themeColor, setThemeColor }
}
